import { render, staticRenderFns } from "./SalesReportSortByTotals.vue?vue&type=template&id=2fb46730&"
import script from "./SalesReportSortByTotals.vue?vue&type=script&lang=ts&"
export * from "./SalesReportSortByTotals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports